import { For } from '../c-mp/comp/For'
import { defineComponent } from '../c-mp/fun/defineComponent'
import { useMemo } from '../c-mp/fun/useMemo'
import { getDataOrThrow } from '../fun/getDataOrThrow'
import { getParentless } from '../fun/getParentless'
import { setPageTitle } from '../fun/setPageTitle'
import { _ } from '../model/ccc'
import { Relationship } from '../model/Relationship'
import { PersonLinkComp } from './PersonLinkComp'

export const PageParentlessComp = defineComponent<{}>(
	'PageParentlessComp',
	(props, $) => {
		setPageTitle(`Ősök`)

		const data = getDataOrThrow()

		const getParentlessCached = useMemo('getParentlessCached', () =>
			getParentless(data),
		)

		return (
			<div class={_.ccc_page}>
				<h1>
					<b>Ősök</b>
				</h1>
				<p>
					Ide tartoznak mindazok a Parditkák és Perczék, akiknek a szüleiről
					nincs adatunk.
				</p>
				<h2>Parditkák</h2>
				<div class={_.ccc_tiles__centered}>
					<For
						debugName='Parditka ősök'
						each={() =>
							getParentlessCached().filter(
								(it) => it.relationship === Relationship.Parditka,
							)
						}
						render={PersonLinkComp}
					/>
				</div>
				<h2>Perczék</h2>
				<div class={_.ccc_tiles__centered}>
					<For
						debugName='Percze ősök'
						each={() =>
							getParentlessCached().filter((it) =>
								it.lastName?.includes('Percze'),
							)
						}
						render={PersonLinkComp}
					/>
				</div>
			</div>
		)
	},
)
